/**
 * Query из Play-приложения: JWT входа и выбранный тариф.
 */
import type { LocationQuery, LocationQueryRaw } from 'vue-router'
import { useAuthStore } from '@/modules/auth/stores/authStore'

/**
 * Забирает из адреса вход из приложения: токены и tariffId.
 * Сценарий from=app не трогает — его обрабатывает AuthPage.
 *
 * @param query — текущие query-параметры
 * @returns query без служебных полей, если что-то забрали; иначе null
 */
export async function consumeAppCheckoutQuery(
  query: LocationQuery,
): Promise<LocationQueryRaw | null> {
  if (query.from === 'app') return null

  const accessToken =
    (typeof query.accessToken === 'string' && query.accessToken) ||
    (typeof query.access_token === 'string' && query.access_token) ||
    (typeof query.auth_token === 'string' && query.auth_token) ||
    ''

  const refreshToken =
    (typeof query.refreshToken === 'string' && query.refreshToken) ||
    (typeof query.refresh_token === 'string' && query.refresh_token) ||
    ''

  const tariffId =
    (typeof query.tariffId === 'string' && query.tariffId) ||
    (typeof query.tariff_id === 'string' && query.tariff_id) ||
    ''

  if (!accessToken && !refreshToken && !tariffId) return null

  if (tariffId) {
    localStorage.setItem('vpn_pending_tariff_id', tariffId)
  }
  if (accessToken) {
    const authStore = useAuthStore()
    await authStore.loginWithTokens(accessToken, refreshToken)
  }

  const next: LocationQueryRaw = { ...query }
  delete next.accessToken
  delete next.access_token
  delete next.auth_token
  delete next.refreshToken
  delete next.refresh_token
  delete next.tariffId
  delete next.tariff_id
  return next
}
